/**
 * Lifecycle state of a voting, derived server-side from its dates.
 *  - DRAFT:       not started yet. Editable and deletable (admin).
 *  - IN_PROGRESS: open for voting. Only deletable; residents vote / change vote.
 *  - CLOSED:      finished. Only deletable. Results visible to everyone.
 */
export enum VotingState {
  DRAFT = "DRAFT",
  IN_PROGRESS = "IN_PROGRESS",
  CLOSED = "CLOSED",
}

/** A voter shown to the administrator (votes are not anonymous). */
export interface VotingVoter {
  idUser: number;
  name: string;
}

export interface VotingOption {
  id?: number;
  text: string;
  position?: number;
  /** Filled only when results are visible (closed, or admin live). */
  votes?: number;
  percentage?: number;
  /** Voters of this option. Admin only. */
  voters?: Array<VotingVoter>;
}

export interface VotingFile {
  id: number;
  filename: string;
}

export class Voting {
  public id?: number;
  public idArea: number;
  public title: string;
  public description: string;
  public dateFrom: string;
  public dateTo: string;
  public multipleChoice: boolean;
  public state?: VotingState;
  public options: Array<VotingOption> = [];
  public files: Array<VotingFile> = [];
  public totalVoters?: number;
  public totalEligible?: number;
  public hasVoted?: boolean;
  public userOptionIds?: Array<number>;
  public resultsVisible?: boolean;

  constructor(voting?: any) {
    if (voting) {
      Object.assign(this, voting);
    }
  }
}

export interface VotingStatus {
  hasPendingVote: boolean;
}
